module.exports = __webpack_public_path__ + "img/63-l.31ea54ee.png";